// @flow

import type { Action } from './store.type';

export const GET_FONT_LIST_REQUEST = 'GET_FONT_LIST_REQUEST';
type GET_FONT_LIST_REQUEST_TYPE = 'GET_FONT_LIST_REQUEST';

export const GET_FONT_LIST_SUCCESS = 'GET_FONT_LIST_SUCCESS';
type GET_FONT_LIST_SUCCESS_TYPE = 'GET_FONT_LIST_SUCCESS';

export const GET_FONT_LIST_FAILURE = 'GET_FONT_LIST_FAILURE';
type GET_FONT_LIST_FAILURE_TYPE = 'GET_FONT_LIST_FAILURE';

type FontSuccess = {
  data: Object
};

type FontFailure = {
  error: any
};

type GetFontListRequestAction = Action<GET_FONT_LIST_REQUEST_TYPE, null>;

type GetFontListSuccessAction = Action<GET_FONT_LIST_SUCCESS_TYPE, FontSuccess>;

type GetFontListFailureAction = Action<GET_FONT_LIST_FAILURE_TYPE, FontFailure>;

export type FontAction =
  | GetFontListRequestAction
  | GetFontListSuccessAction
  | GetFontListFailureAction;

export type FontState = {
  fontListLoading: boolean,
  fontListSuccess: boolean,
  error: any,
  fontList: Array<Object>
};
